<template>
  <v-navigation-drawer
    v-model="state.open"
    right
    temporary
    app
    class="pay-range-version-drawer-connected"
    width="min(720px, 92vw)"
  >
    <PayRangeVersionDrawer
      v-if="state.props"
      v-bind="state.props"
      :feature-enabled="featureEnabled"
      @open-chatter="openChatter"
      @close="close"
    />
  </v-navigation-drawer>
</template>

<script setup>
import { watch } from "vue";
import PayRangeVersionDrawer from "@components/PayRangeVersionDrawer/PayRangeVersionDrawer.vue";
import { usePayRangeVersionDrawer } from "./composables/usePayRangeVersionDrawer";

defineProps({
  featureEnabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["open-chatter", "closed"]);

const { state, open, close } = usePayRangeVersionDrawer();

// A temporary drawer also closes on an outside click, which must clear the bar selection too.
watch(
  () => state.open,
  (isOpen) => {
    if (!isOpen) emit("closed");
  }
);

function openChatter() {
  emit("open-chatter", {
    id: state.versionId,
    versionCode: state.props?.payRangeVersion.code,
  });
}

defineExpose({ open, close });
</script>
